const PROD_PAGES = {
  '/sports': () => import('./configModules/sports'),
  '/in-play': () => import('./configModules/in-play'),
  '/cybersport': () => import('./configModules/cybersport'),
  '/personal-office': () => import('./configModules/personal-office'),
  '/login': () => import('./pages/login'),
  '/register': () => import('./configModules/register'),
  '/forgot-password': () => import('./pages/forgot-password'),
  '/casino': () => import('./configModules/casino'),
  '/promos': () => import('./configModules/promos'),
  '/terms-and-conditions': () => import('./pages/terms-conditions'),
  '/privacy-policy': () => import('./pages/privacy-policy'),
  '/cookie-policy': () => import('./pages/cookie-policy'),
  '/responsible-gambling': () => import('./pages/responsible-gaming'),
  '/about-us': () => import('./pages/about-us'),
  '/rules': () => import('./pages/games-info'),
  '/keno': () => import('./pages/keno'),
  '/rules-egt': () => import('./pages/games-info-egt'),
  '/rules-greentube': () => import('./pages/games-info-greentube'),
  '/rules-evolution': () => import('./pages/games-info-evolution'),
  '/rules-gamomat': () => import('./pages/games-info-gamomat'),
  '/rules-kalamba': () => import('./pages/games-info-kalamba'),
  '/rules-netent': () => import('./pages/games-info-netent'),
  '/rules-oryx': () => import('./pages/games-info-oryx'),
  '/payments': () => import('./pages/payments'),
  '/deposit-neteller': () => import('./pages/deposit-neteller'),
  '/deposit-skrill': () => import('./pages/deposit-skrill'),
  '/deposit-safecharge': () => import('./pages/deposit-safecharge'),
  '/welcome': () => import('./pages/welcome'),
  '/results': () => import('./pages/results'),
  '/rules-regulament': () => import('./pages/rules-regulament'),
  '/casino-live': () => import('./configModules/casino-live'),
  '/instant-games': () => import('./configModules/instant-games'),
  '/lottery': () => import('./pages/lottery'),
  '/aml_kyc': () => import('./pages/aml-kyc'),
  '/license': () => import('./pages/license'),
  '/bets': () => import('./pages/bets-redirect'),
  '/quiz': () => import('./pages/quiz'),
  '/goldenrace': () => import('./pages/goldenrace-lobby'),
  '/virtual-sports': () => import('./configModules/virtual-sports'),
  '/euro-predictions': () => import('./configModules/euro-predictions'),
  '/euro-predictions-mobile': () =>
    import('./configModules/euro-predictions-mobile'),
  '/error-email-verification': () => import('./pages/error-email-verification'),
  '/successful-email-verification': () =>
    import('./pages/successful-email-verification'),
  '/cookie-declaration': () => import('./pages/cookie-declaration'),
  '/settings': () => import('./pages/settings')
};

const DEV_PAGES = {
  '/valya': () => import('./pages/valya-test')
}; // todo remove after tests

export const FALLBACK_PAGES =
  process.env.NODE_ENV === 'development'
    ? { ...PROD_PAGES, ...DEV_PAGES }
    : PROD_PAGES;
